import { createClient } from '@supabase/supabase-js'

// Use environment variables with fallbacks
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://rbmleqmfeewmkvmlxblf.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJibWxlcW1mZWV3bWt2bWx4YmxmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk4ODUyNjEsImV4cCI6MjA4NTQ2MTI2MX0.5W5ZEwGFlbCYe2DjT6HBtnMR3BMmLWEQVmpnG9uzB4s'
console.log('🔧 Supabase Client Configuration:')
console.log('Environment:', process.env.NODE_ENV || 'development')
console.log('URL:', supabaseUrl)
console.log('Anon Key:', supabaseAnonKey ? '✓ Exists' : '✗ Missing')

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage
  }
})

console.log('✅ Supabase client initialized successfully')